import Env from '../base/env'
import ShopifyBuy from 'shopify-buy';
import Waypoint from '../vendor/waypoints'

export default class InstantBuy
{
    constructor(view)
    {
        this.view = view
        this.$reference = this.view.querySelector('.jsInstantBuy--view')
        if(this.$reference == null) {
            return false;
        }
        this.getHandle = this.$reference.getAttribute('data-id')
        this.client = ShopifyBuy.buildClient({
            domain: 'goodmoods-editions.myshopify.com',
            storefrontAccessToken: '0f202296e0fb27a43a6bedb5f291860e'
        });
        this.lineItemsToAdd = []
        this.checkoutID = false
        this.setup()
        this.waypoint()
    }

    setup()
    {
        this.client.checkout.create().then((checkout) => {
            this.checkoutID = checkout.id
        });
        this.client.product.fetchByHandle(this.getHandle).then((product) => {
            this.lineItemsToAdd.push({
                variantId: product.variants[0].id,
                quantity: 1,
            });
        });
        setTimeout(() => {
            this.client.checkout.addLineItems(this.checkoutID, this.lineItemsToAdd).then((checkout) => {
                const $receptors = document.querySelectorAll('.jsInstantBuy--receptor')
                for (let $receptor of $receptors) {
                    $receptor.setAttribute('href',checkout.webUrl)
                }
            });
        }, 2500);
    }

    waypoint()
    {
        const instanceShown = new Waypoint({
            element: this.view.querySelector('.jsInstantBuy--listener'),
            handler: (direction)=> {
                if(direction === 'down') {
                    Env.$html.classList.add('buyBar--isVisible')
                } else {
                    Env.$html.classList.remove('buyBar--isVisible')
                }
            },
            offset: '-100%'
        });
    }
}